<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员日志" name="eleven"> </el-tab-pane>
      <el-tab-pane label="会员成绩日志" name="twelve"> </el-tab-pane>
      <el-tab-pane label="会员比赛日志" name="thirteen"> </el-tab-pane>
      <el-tab-pane label="日榜" name="six"> </el-tab-pane>
      <el-tab-pane label="组数王" name="seven"> </el-tab-pane>
      <el-tab-pane label="资讯管理" name="one"> </el-tab-pane>
      <el-tab-pane label="活动管理" name="two"> </el-tab-pane>
      <el-tab-pane label="活动报名" name="three"> </el-tab-pane>
      <el-tab-pane label="赛事管理" name="four">
        <div>
          <div class="title_div">
            <span class="title-span">榜单:</span>
            <el-input
              clearable
              class="widthClass title-select"
              size="small"
              v-model="ssParams.gameName"
              @input="inputGameName"
            ></el-input>
            <span class="title-span">弓种:</span>
            <el-select
              clearable
              size="small"
              class="title-select"
              v-model="ssParams.bowType"
              @change="bowTypeChanges"
            >
              <el-option
                v-for="item in bowTypeList"
                :label="item.title"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
            <span class="title-span">米数:</span>
            <el-select
              clearable
              size="small"
              class="title-select"
              v-model="ssParams.meterType"
              @change="meterTypeChange"
            >
              <el-option
                v-for="item in this.meterTypeList"
                :label="item.title"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
            <span class="title-span">日期:</span>
            <el-date-picker
              @change="startChange"
              v-model="ssParams.createDate"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
          </div>
          <div>
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="creatDialogVisible = true"
              >创建赛事
            </el-button>
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="copyOut"
              >导出
            </el-button>
          </div>
          <div class="mm-tb">
            <el-table :data="ssList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="gameName"
                label="榜单"
                align="center"
                width="180"
              >
                <template slot-scope="scope">
                  <div
                    @click="getGameListTop10Page(scope.row)"
                    style="color: #409eff"
                  >
                    {{ scope.row.gameName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="targetSheet_text"
                label="靶纸"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="groupCountType_text"
                label="组数"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="groupArrow_text"
                label="每组"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="bowType_text" label="弓种" align="center">
              </el-table-column>
              <el-table-column
                prop="meterType_text"
                label="米数"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="gameDateStart"
                label="开始时间"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="gameDateEnd"
                label="结束时间"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                label="操作"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="editSS(scope.row.id)"
                    >编辑</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="ssSizeChange"
              @current-change="ssCurrentChange"
              :current-page="ssResult.current"
              :page-size="ssResult.size"
              layout="total,prev, pager, next, sizes"
              :total="ssResult.total"
              :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="日榜管理" name="five"> </el-tab-pane>

      <el-tab-pane label="段位管理" name="eight"> </el-tab-pane>
      <el-tab-pane label="勋章管理" name="nine"> </el-tab-pane>
      <el-tab-pane label="订单项管理" name="ten"> </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="创建赛事"
      :visible.sync="creatDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <div class="dialog-div">
        <span class="title-span">赛 事 名 称:</span>
        <el-input
          size="small"
          class="title-select1"
          v-model="ssCreatParams.gameName"
        ></el-input>
      </div>
      <div class="dialog-div">
        <span class="title-span"
          >弓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;种:</span
        >
        <el-select
          size="small"
          class="title-select1"
          v-model="ssCreatParams.bowType"
          @change="bowTypeChange"
        >
          <el-option
            v-for="item in this.bowTypeList"
            :label="item.title"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-div">
        <span class="title-span"
          >米&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数:</span
        >
        <el-select
          size="small"
          class="title-select1"
          v-model="ssCreatParams.meterType"
          @change="bowTypeChange"
        >
          <el-option
            v-for="item in this.meterTypeList"
            :label="item.title"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-div">
        <span class="title-span"
          >组&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数:</span
        >
        <el-select
          size="small"
          class="title-select1"
          v-model="ssCreatParams.groupCountType"
          @change="bowTypeChange"
        >
          <el-option
            v-for="item in this.groupCountTypeList"
            :label="item.title"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-div">
        <span class="title-span">每 组 箭 支:</span>
        <el-select
          size="small"
          class="title-select1"
          v-model="ssCreatParams.groupArrow"
          @change="bowTypeChange"
        >
          <el-option
            v-for="item in this.groupArrowList"
            :label="item.title"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-div">
        <span class="title-span"
          >靶&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;纸:</span
        >
        <el-select
          size="small"
          class="title-select1"
          v-model="ssCreatParams.targetSheet"
          @change="bowTypeChange"
        >
          <el-option
            v-for="item in this.targetSheetList"
            :label="item.title"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="dialog-div">
        <span class="title-span">开 始 日 期:</span>
        <el-date-picker
          v-model="ssCreatParams.gameDateStart"
          size="small"
          class="title-date1"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择开始日期"
        >
        </el-date-picker>
      </div>
      <div class="dialog-div">
        <span class="title-span">结 束 日 期:</span>
        <el-date-picker
          v-model="ssCreatParams.gameDateEnd"
          size="small"
          class="title-date1"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择开始日期"
        >
        </el-date-picker>
      </div>

      <!-- <div class="dialog-div" style="height: 160px">
        <span class="title-span" style="float: left">封 面 照 片:</span>
        <el-upload
          style="float: left"
          class="avatar-uploader"
          accept=".png,.jpg,.jpeg,.JPG,.JPEG"
          :headers="headers"
          :action="upLoadUrl"
          :show-file-list="false"
          :on-success="creatHandleAvatarSuccess"
          :before-upload="creatBeforeAvatarUpload"
        >
          <img v-if="creatImageUrl" :src="creatImageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="creatDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="creatCommit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑赛事"
      :visible.sync="editDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <div class="dialog-div">
        <span class="title-span">赛 事 名 称:</span>
        <el-input
          size="small"
          class="title-select1"
          v-model="ssEditParams.gameName"
        ></el-input>
      </div>
      <div class="dialog-div">
        <span class="title-span"
          >弓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;种:</span
        >
        <el-select
          size="small"
          class="title-select1"
          v-model="ssEditParams.bowType"
          @change="bowTypeChange"
        >
          <el-option
            v-for="item in bowTypeList"
            :label="item.title"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-div">
        <span class="title-span"
          >米&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数:</span
        >
        <el-select
          size="small"
          class="title-select1"
          v-model="ssEditParams.meterType"
          @change="bowTypeChange"
        >
          <el-option
            v-for="item in meterTypeList"
            :label="item.title"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-div">
        <span class="title-span"
          >组&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数:</span
        >
        <el-select
          size="small"
          class="title-select1"
          v-model="ssEditParams.groupCountType"
          @change="bowTypeChange"
        >
          <el-option
            v-for="item in groupCountTypeList"
            :label="item.title"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-div">
        <span class="title-span">每 组 箭 支:</span>
        <el-select
          size="small"
          class="title-select1"
          v-model="ssEditParams.groupArrow"
          @change="bowTypeChange"
        >
          <el-option
            v-for="item in groupArrowList"
            :label="item.title"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-div">
        <span class="title-span"
          >靶&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;纸:</span
        >
        <el-select
          size="small"
          class="title-select1"
          v-model="ssEditParams.targetSheet"
          @change="bowTypeChange"
        >
          <el-option
            v-for="item in this.targetSheetList"
            :label="item.title"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="dialog-div">
        <span class="title-span">开 始 日 期:</span>
        <el-date-picker
          v-model="ssEditParams.gameDateStart"
          size="small"
          class="title-date1"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择开始日期"
        >
        </el-date-picker>
      </div>
      <div class="dialog-div">
        <span class="title-span">结 束 日 期:</span>
        <el-date-picker
          v-model="ssEditParams.gameDateEnd"
          size="small"
          class="title-date1"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择开始日期"
        >
        </el-date-picker>
      </div>

      <!-- <div class="dialog-div" style="height: 160px">
        <span class="title-span" style="float: left">封 面 照 片:</span>
        <el-upload
          style="float: left"
          class="avatar-uploader"
          accept=".png,.jpg,.jpeg,.JPG,.JPEG"
          :headers="headers"
          :action="upLoadUrl"
          :show-file-list="false"
          :on-success="editHandleAvatarSuccess"
          :before-upload="editBeforeAvatarUpload"
        >
          <img v-if="editImageUrl" :src="editImageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editCommit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 比赛排名 -->
    <el-dialog
      :title="gameTitle"
      :visible.sync="dialogVisibleGameUp"
      width="40%"
      :close-on-click-modal="false"
    >
      <el-table :data="gameData" style="width: 100%">
        <el-table-column
          prop="ranking"
          label="选手名次"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="memberName"
          label="选手姓名"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="totalScore" label="选手成绩" align="center">
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="medium"
              @click="seeRb(scope.row.photoPath)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mm-page"
        @size-change="SizeChange"
        @current-change="hdCurrentChange"
        :current-page="gameDataResult.current"
        :page-size="gameDataResult.size"
        layout="total,prev, pager, next, sizes"
        :total="gameDataResult.total"
        :page-sizes="[10, 20, 30, 40, 50]"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleGameUp = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="图片查看"
      :visible.sync="photoDialogVisible"
      width="700px"
      style="text-align: center"
      :close-on-click-modal="false"
    >
      <el-image
        v-for="(item, index) in this.photoList"
        lazy
        style="width: 200px; height: 200px; margin: 10px"
        :src="item"
        :key="index"
        :preview-src-list="photoList"
      >
      </el-image>

      <!--      <span slot="footer" class="dialog-footer">-->
      <!--              <el-button @click="editDialogVisible = false">取 消</el-button>-->
      <!--              <el-button type="primary" >确 定</el-button>-->
      <!--            </span>-->
    </el-dialog>
  </div>
</template>

<script>
import {
  getGamePageList,
  getGameInfo,
  updateGameInfo,
  addGameInfo,
  groupArrow,
  bowTypes,
  groupCountType,
  meterType,
  targetSheet,
  gameMeter,
  getGameListTop10Page,
  getGamePageListForExcel,
} from "../../api/OperationManagement.js";
import { globelurl, posturl } from "../../api/axios.js";
import {
  getAntEventById,
  getEventPageList,
  medalGetType,
  updateAntEvent,
} from "../../api/OperationManagement";

export default {
  name: "4EventManagement",
  data() {
    return {
      activeName: "four",
      upLoadUrl: posturl,
      titleUrl: globelurl,
      headers: { "X-Access-Token": sessionStorage.token },
      ssParams: {
        gameName: "",
        bowType: "",
        meterType: "",
        createDate: "",
        pageNo: 1,
        pageSize: 10,
      },
      ssResult: {},
      ssList: [],
      groupArrowList: [],
      bowTypeList: [],
      groupCountTypeList: [],
      meterTypeList: [],
      targetSheetList: [],
      creatDialogVisible: false,
      creatImageUrl: "",
      ssCreatParams: {
        gameName: "",
        bowType: "",
        meterType: "",
        groupCountType: "",
        groupArrow: "",
        targetSheet: "",
        gameDateStart: "",
        gameDateEnd: "",
        logoPath: "",
      },
      editDialogVisible: false,
      ssEditParams: {
        id: "",
        gameName: "",
        bowType: "",
        meterType: "",
        groupCountType: "",
        groupArrow: "",
        targetSheet: "",
        gameDateStart: "",
        gameDateEnd: "",
        logoPath: "",
      },
      editImageUrl: "",
      dialogVisibleGameUp: false,
      gameTitle: "",
      gameData: [],
      gameDataResult: {},
      gameListParms: {
        gameId: "",
        pageNo: 1,
        pageSize: 10,
      },
      photoList: [],
      photoDialogVisible: false,
    };
  },
  mounted() {
    this.getGamePageList(this.ssParams);
    this.groupArrow();
    this.bowType();
    this.groupCountType();
    this.targetSheet();
    // this.meterType()
    this.gameMeter();
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "资讯管理") {
        this.$router.push("/OperationManagement/1InformationManagement");
      } else if (tab.label == "活动管理") {
        this.$router.push("/OperationManagement/2ActivityManagement");
      } else if (tab.label == "活动报名") {
        this.$router.push("/OperationManagement/3ActivityRegistration");
      } else if (tab.label == "赛事管理") {
        // this.$router.push('/OperationManagement/4EventManagement');
      } else if (tab.label == "日榜管理") {
        this.$router.push("/OperationManagement/5RankingList");
      } else if (tab.label == "日榜") {
        this.$router.push("/OperationManagement/6ListManagement");
      } else if (tab.label == "组数王") {
        this.$router.push("/OperationManagement/7GroupNumberList");
      } else if (tab.label == "段位管理") {
        this.$router.push("/OperationManagement/8RankManagement");
      } else if (tab.label == "勋章管理") {
        this.$router.push("/OperationManagement/9MedalManagement");
      } else if (tab.label == "订单项管理") {
        this.$router.push("/OperationManagement/10MedalManagement");
      } else if (tab.label == "会员日志") {
        this.$router.push("/OperationManagement/11MedalManagement");
      } else if (tab.label == "会员成绩日志") {
        this.$router.push("/OperationManagement/12MedalManagement");
      } else if (tab.label == "会员比赛日志") {
        this.$router.push("/OperationManagement/13MedalManagement");
      }
    },
    ssSizeChange(newSize) {
      this.ssParams.pageSize = newSize;
      this.getGamePageList(this.ssParams);
    },
    ssCurrentChange(newPage) {
      this.ssParams.pageNo = newPage;
      this.getGamePageList(this.ssParams);
    },
    //获取赛事列表
    getGamePageList(params) {
      getGamePageList(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.ssResult = res.data.result;
            this.ssList = res.data.result.records;
          } else {
            this.ssResult = res.data.result;
            this.ssList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 获取每组箭支字典
    groupArrow() {
      groupArrow().then((res) => {
        if (res.data.success) {
          this.groupArrowList = res.data.result;
        }
      });
    },
    // 获取米数字典
    // meterType() {
    //   meterType().then((res) => {
    //     if (res.data.success) {
    //       this.meterTypeList = res.data.result;
    //     }
    //   });
    // },
    // 比赛米数字典
    gameMeter() {
      gameMeter().then((res) => {
        if (res.data.success) {
          this.meterTypeList = res.data.result;
        }
      });
    },
    // 获取弓种字典
    bowType() {
      bowTypes().then((res) => {
        if (res.data.success) {
          this.bowTypeList = res.data.result;
        }
      });
    },
    // 获取组数字典
    groupCountType() {
      groupCountType().then((res) => {
        if (res.data.success) {
          this.groupCountTypeList = res.data.result;
        }
      });
    },

    // 获取靶纸字典
    targetSheet() {
      targetSheet().then((res) => {
        if (res.data.success) {
          this.targetSheetList = res.data.result;
        }
      });
    },
    getGameListTop10Page(row) {
      this.dialogVisibleGameUp = true;
      this.gameTitle = row.gameName;
      this.gameListParms.gameId = row.id;
      this.getGameListTop10Pages();
    },
    getGameListTop10Pages() {
      getGameListTop10Page({ ...this.gameListParms }).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.gameDataResult = res.data.result;
          this.gameData = res.data.result.records;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    inputGameName() {
      this.ssParams.pageNo = 1;
      this.getGamePageList(this.ssParams);
    },
    //弓种下拉更改
    bowTypeChanges() {
      this.ssParams.pageNo = 1;
      this.getGamePageList(this.ssParams);
    },
    //米数下拉更改
    meterTypeChange() {
      this.ssParams.pageNo = 1;
      this.getGamePageList(this.ssParams);
    },
    //开始时间更改
    startChange() {
      this.ssParams.pageNo = 1;
      this.getGamePageList(this.ssParams);
    },
    bowTypeChange() {
      this.getGamePageList(this.ssParams);
    },
    SizeChange(newSize) {
      this.gameListParms.pageSize = newSize;
      this.getGameListTop10Pages();
    },
    hdCurrentChange(newPage) {
      this.gameListParms.pageNo = newPage;
      this.getGameListTop10Pages();
    },
    //创建活动图片上传
    creatHandleAvatarSuccess(res, file) {
      this.ssCreatParams.logoPath = res.result.pathList[0];
      this.creatImageUrl = globelurl + res.result.pathList[0];
    },
    creatBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    //创建活动提交
    creatCommit() {
      if (this.ssCreatParams.gameName == "") {
        this.$message.error("请输入赛事名称");
      } else if (this.ssCreatParams.bowType == "") {
        this.$message.error("请选择赛事弓种");
      } else if (this.ssCreatParams.meterType == "") {
        this.$message.error("请选择赛事米数");
      } else if (this.ssCreatParams.groupCountType == "") {
        this.$message.error("请选择赛事组数");
      } else if (this.ssCreatParams.groupArrow == "") {
        this.$message.error("请选择赛事每组箭支");
      } else if (this.ssCreatParams.targetSheet == "") {
        this.$message.error("请选择赛事靶纸");
      } else if (this.ssCreatParams.gameDateStart == "") {
        this.$message.error("请选择赛事开始日期");
      } else if (this.ssCreatParams.gameDateEnd == "") {
        this.$message.error("请选择赛事结束日期");
      }
      // else if (this.ssCreatParams.logoPath == "") {
      //   this.$message.error("请选择活动封面图片");
      // }
      else {
        addGameInfo(this.ssCreatParams).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("创建赛事成功");
              this.creatDialogVisible = false;
              this.getGamePageList(this.ssParams);
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },

    //获取赛事信息
    editSS(val) {
      getGameInfo({ id: val }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.editDialogVisible = true;
            this.ssEditParams.id = res.data.result.id;
            this.ssEditParams.gameName = res.data.result.gameName;
            this.ssEditParams.bowType = res.data.result.bowType;
            this.ssEditParams.meterType = res.data.result.meterType;
            this.ssEditParams.groupCountType = res.data.result.groupCountType;
            this.ssEditParams.groupArrow = res.data.result.groupArrow;
            this.ssEditParams.targetSheet = res.data.result.targetSheet;
            this.ssEditParams.gameDateStart = res.data.result.gameDateStart;
            this.ssEditParams.gameDateEnd = res.data.result.gameDateEnd;
            this.ssEditParams.logoPath = res.data.result.logoPath;
            this.editImageUrl = globelurl + res.data.result.logoPath;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //编辑活动提交
    editCommit() {
      if (this.ssEditParams.gameName == "") {
        this.$message.error("请输入赛事名称");
      } else if (this.ssEditParams.bowType == "") {
        this.$message.error("请选择赛事弓种");
      } else if (this.ssEditParams.meterType == "") {
        this.$message.error("请选择赛事米数");
      } else if (this.ssEditParams.groupCountType == "") {
        this.$message.error("请选择赛事组数");
      } else if (this.ssEditParams.groupArrow == "") {
        this.$message.error("请选择赛事每组箭支");
      } else if (this.ssEditParams.targetSheet == "") {
        this.$message.error("请选择赛事靶纸");
      } else if (this.ssEditParams.gameDateStart == "") {
        this.$message.error("请选择赛事开始日期");
      } else if (this.ssEditParams.gameDateEnd == "") {
        this.$message.error("请选择赛事结束日期");
      }
      //  else if (this.ssEditParams.logoPath == "") {
      //   this.$message.error("请选择活动封面图片");
      // }
      else {
        updateGameInfo(this.ssEditParams).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("编辑赛事成功");
              this.editDialogVisible = false;
              this.getGamePageList(this.ssParams);
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //编辑活动图片上传
    editHandleAvatarSuccess(res, file) {
      this.ssEditParams.logoPath = res.result.pathList[0];
      this.editImageUrl = globelurl + res.result.pathList[0];
    },

    editBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    //查看图片列表
    seeRb(photo) {
      const imgList = photo.split(",");
      this.photoList = [];
      imgList.forEach((itm) => {
        this.photoList.push(this.titleUrl + itm);
      });

      this.photoDialogVisible = true;
    },
    // 导出
    copyOut() {
      getGamePageListForExcel(this.ssParams).then((res) => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = "联赛成绩导出";
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      });
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.orderMain {
  padding: 30px;
}

.title_div {
  margin: 20px 30px;
}

.title-select1 {
  margin: 0 20px;
  width: 250px;
}

.title-select {
  margin: 0 20px;
  width: 180px;
}

.title-date1 {
  margin-left: 20px;
  width: 250px;
}

.title-date2 {
  width: 250px;
}

.creat-button {
  margin: 20px 8px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}

.dialog-div {
  margin: 20px 50px;
}
</style>


<style>
.el-upload {
  border: 1px dashed #d9d9d9;
  margin-left: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.widthClass {
  width: 15%;
}
</style>
